<template>
  <div :class="getClass()">
    <v-text-field v-if="mode === 'edit'" v-model="data[model.name]" dense hide-details class="no-underline" type="number" @blur="mode = 'view'"></v-text-field>

    <a-view-number v-else :value="value" :style="style" @click="onClick()" />
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    values: {
      type: Object,
      default: () => {},
    },
    model: { type: Object, default: () => {} },
  },
  data() {
    return {
      mode: "view",
    };
  },
  computed: {
    style() {
      let style = "";
      if (this.model?.style) style = this.model?.style;
      return style;
    },
    textColor() {
      if (!this.model?.textColor) return false;
      return this.model?.textColor(this.values);
    },
  },
  methods: {
    onClick() {
      if (this.model?.edit) this.mode = "edit";
    },
    getClass() {
      let classStr = "";
      if (this.model?.class) classStr = this.model?.class;
      if (this.textColor) classStr += " red--text";
      return classStr;
    },
  },
};
</script>
